import 'jquery';
window.jQuery = $;
window.$ = $;
import 'popper.js';
import 'bootstrap';
// import 'datatables.net';
import 'datatables.net-bs4';
// import 'datatables.net-responsive';
import 'datatables.net-responsive-bs4';
import 'select2';
import 'easy-responsive-tabs';
import 'jquery-match-height';
import 'jquery-mousewheel';
import 'malihu-custom-scrollbar-plugin';
import 'bootstrap-show-modal';
import 'bootstrap-show-notification/src/bootstrap-show-notification.js';
import accounting from 'accounting';
window.accounting = accounting;

import '@fancyapps/fancybox';
import 'parsleyjs';
import Mustache from 'mustache';
window.Mustache = Mustache;

import 'jquery-serializejson';
import 'jquery-confirm';
import 'jquery.cookie';

import 'bootstrap-datepicker';
import './clientexec.js';
import './main.js';
import './support.js';